// 将返回的coupons数据格式化成 @tencent/wphk-act-base-components 的 casheCoupon 所需的数据
import { CouponState, CouponInfo, CardType } from '../../type';
import { CouponState as CashCouponState, ICashCouponInfo, ExchangeState } from '@tencent/wphk-act-base-components';
import { CouponType, getValidCurrencyType } from '@tencent/wphk-act-base-ui';
import { amount } from '@tencent/wphk-base-utils';

export const formatCoupon = (couponInfo: CouponInfo, isShowButton: boolean) => {
  const merchantInfo = couponInfo.merchantInfo!;
  const formatedCoupon: ICashCouponInfo = {
    couponState: convertCouponState(couponInfo.state),
    exchangeState: convertExchangeState(couponInfo.state),
    userCouponid: couponInfo.couponId,
    isShowUseBtn: true,
    couponName: couponInfo.couponName,
    couponDesc: couponInfo.couponCondition,
    discount: +couponInfo.couponValue,
    mrchName: merchantInfo.spName,
    mrchLogo: merchantInfo.spLogo,
    isSpCoupon: couponInfo.type === CardType.DisplayCoupon,  // 展示券才需要“手动开启”
    isShowButton,
    currencyType: getValidCurrencyType(couponInfo.currencyType),
  };
  // 对于金额小于1港币的券，转换成折扣券
  const { discount } = formatedCoupon;
  if (discount < 1) {
    formatedCoupon.couponType = CouponType.discount;
    formatedCoupon.discount = amount.yuan2fen(discount.toString());
  }
  return formatedCoupon;
};

/** 将商户展示券的状态转换为标准现金券状态 */
export const convertCouponState = (state: CouponState): CashCouponState => {
  switch (state) {
    case CouponState.Expired:
      return CashCouponState.expired;
    case CouponState.Got:
      return CashCouponState.received;
    case CouponState.Used:
      return CashCouponState.used;
    case CouponState.Normal:
    // 未开始、已领完，券的状态都为可领取。这两种状态在 exchangeState 中再传给 BasicCoupon
    case CouponState.Locked:
    case CouponState.Empty:
    default:
      return CashCouponState.notReceived;
  }
};

export const convertExchangeState = (state: CouponState): ExchangeState => {
  switch (state) {
    case CouponState.Locked:
      return ExchangeState.notStarted;
    case CouponState.Empty:
      return ExchangeState.totalUserLmit;
    default:
      return ExchangeState.avaliable;
  }
};
